import {Dimensions, Platform} from 'react-native';
import {
  heightPercentageToDP as hp,
  widthPercentageToDP as wp,
} from 'react-native-responsive-screen';

/**
 * this function converts regular react native pixel to
 * device relative pixel size based on horizontal width
 * so all devices will have same output
 */

const {width, height} = Dimensions.get('window');
const ratio = height / width;
const baseRatio = 1.7786666666666;
const baseWidth = 394;

export function px(pixelSize = 1) {
  var widthPx = (((ratio / baseRatio) * width) / baseWidth) * pixelSize;
  if (widthPx > pixelSize) {
    widthPx = pixelSize;
  }
  return Platform.OS === 'android' || Platform.OS === 'web'
    ? widthPx
    : pixelSize;
}

export {wp, hp};
